import RetoolComp from "./retool_components/retool";

export const Supply = () => {
  const deal_uuid = "f85a85ee-7370-11ee-b1b2-d3255d0519a8";
  return <RetoolComp component_uuid={deal_uuid} />;
};
